export const sampledata = [
  {
    merek: "Toyota",
    detail: [
      {
        detail_merek: "AGYA",
        detail_spek: [
          {
            tahun: "2015",
            tipe: "E",
            mesin: "1000",
            transmisi: "Manual",
            harga: 60000000,
          },
          {
            tahun: "2015",
            tipe: "E",
            mesin: "1000",
            transmisi: "Automatic",
            harga: 65000000,
          },
          {
            tahun: "2015",
            tipe: "G",
            mesin: "1000",
            transmisi: "Manual",
            harga: 70000000,
          },
          {
            tahun: "2015",
            tipe: "G",
            mesin: "1000",
            transmisi: "Automatic",
            harga: 75000000,
          },
          {
            tahun: "2015",
            tipe: "TRD Sportivo",
            mesin: "1000",
            transmisi: "Manual",
            harga: 80000000,
          },
          {
            tahun: "2015",
            tipe: "TRD Sportivo",
            mesin: "1000",
            transmisi: "Automatic",
            harga: 90000000,
          },
          {
            tahun: "2016",
            tipe: "E",
            mesin: "1000",
            transmisi: "Manual",
            harga: 65000000,
          },
          {
            tahun: "2016",
            tipe: "E",
            mesin: "1000",
            transmisi: "Automatic",
            harga: 70000000,
          },
          {
            tahun: "2016",
            tipe: "G",
            mesin: "1000",
            transmisi: "Manual",
            harga: 75000000,
          },
          {
            tahun: "2016",
            tipe: "G",
            mesin: "1000",
            transmisi: "Automatic",
            harga: 80000000,
          },
          {
            tahun: "2016",
            tipe: "TRD Sportivo",
            mesin: "1000",
            transmisi: "Manual",
            harga: 85000000,
          },
          {
            tahun: "2016",
            tipe: "TRD Sportivo",
            mesin: "1000",
            transmisi: "Automatic",
            harga: 95000000,
          },
          {
            tahun: "2017",
            tipe: "E",
            mesin: "1000",
            transmisi: "Manual",
            harga: 70000000,
          },
          {
            tahun: "2017",
            tipe: "E",
            mesin: "1200",
            transmisi: "Manual",
            harga: 85000000,
          },
          {
            tahun: "2017",
            tipe: "E",
            mesin: "1000",
            transmisi: "Automatic",
            harga: 75000000,
          },
          {
            tahun: "2017",
            tipe: "E",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 90000000,
          },
          {
            tahun: "2017",
            tipe: "G",
            mesin: "1000",
            transmisi: "Manual",
            harga: 80000000,
          },
          {
            tahun: "2017",
            tipe: "G",
            mesin: "1200",
            transmisi: "Manual",
            harga: 95000000,
          },
          {
            tahun: "2017",
            tipe: "G",
            mesin: "1000",
            transmisi: "Automatic",
            harga: 85000000,
          },
          {
            tahun: "2017",
            tipe: "G",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 100000000,
          },
          {
            tahun: "2017",
            tipe: "TRD Sportivo",
            mesin: "1000",
            transmisi: "Manual",
            harga: 90000000,
          },
          {
            tahun: "2017",
            tipe: "TRD Sportivo",
            mesin: "1200",
            transmisi: "Manual",
            harga: 105000000,
          },
          {
            tahun: "2017",
            tipe: "TRD Sportivo",
            mesin: "1000",
            transmisi: "Automatic",
            harga: 95000000,
          },
          {
            tahun: "2017",
            tipe: "TRD Sportivo",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 110000000,
          },
          {
            tahun: "2018",
            tipe: "E",
            mesin: "1000",
            transmisi: "Manual",
            harga: 80000000,
          },
          {
            tahun: "2018",
            tipe: "E",
            mesin: "1000",
            transmisi: "Automatic",
            harga: 85000000,
          },
          {
            tahun: "2018",
            tipe: "G",
            mesin: "1000",
            transmisi: "Manual",
            harga: 90000000,
          },
          {
            tahun: "2018",
            tipe: "G",
            mesin: "1200",
            transmisi: "Manual",
            harga: 105000000,
          },
          {
            tahun: "2018",
            tipe: "G",
            mesin: "1000",
            transmisi: "Automatic",
            harga: 95000000,
          },
          {
            tahun: "2018",
            tipe: "G",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 110000000,
          },
          {
            tahun: "2018",
            tipe: "TRD Sportivo",
            mesin: "1000",
            transmisi: "Manual",
            harga: 95000000,
          },
          {
            tahun: "2018",
            tipe: "TRD Sportivo",
            mesin: "1200",
            transmisi: "Manual",
            harga: 110000000,
          },
          {
            tahun: "2018",
            tipe: "TRD Sportivo",
            mesin: "1000",
            transmisi: "Automatic",
            harga: 100000000,
          },
          {
            tahun: "2018",
            tipe: "TRD Sportivo",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 115000000,
          },
          {
            tahun: "2019",
            tipe: "G",
            mesin: "1000",
            transmisi: "Manual",
            harga: 95000000,
          },
          {
            tahun: "2019",
            tipe: "G",
            mesin: "1200",
            transmisi: "Manual",
            harga: 110000000,
          },
          {
            tahun: "2019",
            tipe: "G",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 115000000,
          },
          {
            tahun: "2019",
            tipe: "G TRD",
            mesin: "1200",
            transmisi: "Manual",
            harga: 120000000,
          },
          {
            tahun: "2019",
            tipe: "G TRD",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 125000000,
          },
          {
            tahun: "2020",
            tipe: "G",
            mesin: "1200",
            transmisi: "Manual",
            harga: 1150000000,
          },
          {
            tahun: "2020",
            tipe: "G",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 120000000,
          },
          {
            tahun: "2020",
            tipe: "G TRD",
            mesin: "1200",
            transmisi: "Manual",
            harga: 120000000,
          },
          {
            tahun: "2020",
            tipe: "G TRD",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 125000000,
          },
        ],
      },
      {
        detail_merek: "AVANZA",
        detail_spek: [
          {
            tahun: "2015",
            tipe: "E",
            mesin: "1300",
            transmisi: "Manual",
            harga: 100000000,
          },
          {
            tahun: "2015",
            tipe: "E",
            mesin: "1300",
            transmisi: "Automatic",
            harga: 105000000,
          },
          {
            tahun: "2015",
            tipe: "G",
            mesin: "1300",
            transmisi: "Manual",
            harga: 110000000,
          },
          {
            tahun: "2015",
            tipe: "G",
            mesin: "1300",
            transmisi: "Automatic",
            harga: 115000000,
          },
          {
            tahun: "2015",
            tipe: "VELOZ",
            mesin: "1500",
            transmisi: "Manual",
            harga: 120000000,
          },
          {
            tahun: "2015",
            tipe: "VELOZ",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 125000000,
          },
          {
            tahun: "2016",
            tipe: "E",
            mesin: "1300",
            transmisi: "Manual",
            harga: 110000000,
          },
          {
            tahun: "2016",
            tipe: "E",
            mesin: "1300",
            transmisi: "Automatic",
            harga: 115000000,
          },
          {
            tahun: "2016",
            tipe: "G",
            mesin: "1300",
            transmisi: "Manual",
            harga: 115000000,
          },
          {
            tahun: "2016",
            tipe: "G",
            mesin: "1300",
            transmisi: "Automatic",
            harga: 120000000,
          },
          {
            tahun: "2016",
            tipe: "G",
            mesin: "1500",
            transmisi: "Manual",
            harga: 125000000,
          },
          {
            tahun: "2016",
            tipe: "G",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 130000000,
          },
          {
            tahun: "2016",
            tipe: "VELOZ",
            mesin: "1500",
            transmisi: "Manual",
            harga: 130000000,
          },
          {
            tahun: "2016",
            tipe: "VELOZ",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 135000000,
          },
          {
            tahun: "2017",
            tipe: "E",
            mesin: "1300",
            transmisi: "Manual",
            harga: 115000000,
          },
          {
            tahun: "2017",
            tipe: "E",
            mesin: "1300",
            transmisi: "Automatic",
            harga: 120000000,
          },
          {
            tahun: "2017",
            tipe: "G",
            mesin: "1300",
            transmisi: "Manual",
            harga: 125000000,
          },
          {
            tahun: "2017",
            tipe: "G",
            mesin: "1300",
            transmisi: "Automatic",
            harga: 130000000,
          },
          {
            tahun: "2017",
            tipe: "G",
            mesin: "1500",
            transmisi: "Manual",
            harga: 135000000,
          },
          {
            tahun: "2017",
            tipe: "G",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 140000000,
          },
          {
            tahun: "2017",
            tipe: "VELOZ",
            mesin: "1500",
            transmisi: "Manual",
            harga: 145000000,
          },
          {
            tahun: "2017",
            tipe: "VELOZ",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 150000000,
          },
          {
            tahun: "2018",
            tipe: "E",
            mesin: "1300",
            transmisi: "Manual",
            harga: 120000000,
          },
          {
            tahun: "2018",
            tipe: "E",
            mesin: "1300",
            transmisi: "Automatic",
            harga: 125000000,
          },
          {
            tahun: "2018",
            tipe: "G",
            mesin: "1300",
            transmisi: "Manual",
            harga: 130000000,
          },
          {
            tahun: "2018",
            tipe: "G",
            mesin: "1300",
            transmisi: "Automatic",
            harga: 135000000,
          },
          {
            tahun: "2018",
            tipe: "G",
            mesin: "1500",
            transmisi: "Manual",
            harga: 140000000,
          },
          {
            tahun: "2018",
            tipe: "G",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 145000000,
          },
          {
            tahun: "2018",
            tipe: "VELOZ",
            mesin: "1500",
            transmisi: "Manual",
            harga: 150000000,
          },
          {
            tahun: "2018",
            tipe: "VELOZ",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 155000000,
          },
          {
            tahun: "2019",
            tipe: "E",
            mesin: "1300",
            transmisi: "Manual",
            harga: 125000000,
          },
          {
            tahun: "2019",
            tipe: "E",
            mesin: "1300",
            transmisi: "Automatic",
            harga: 130000000,
          },
          {
            tahun: "2019",
            tipe: "G",
            mesin: "1300",
            transmisi: "Manual",
            harga: 135000000,
          },
          {
            tahun: "2019",
            tipe: "G",
            mesin: "1300",
            transmisi: "Automatic",
            harga: 140000000,
          },
          {
            tahun: "2019",
            tipe: "G",
            mesin: "1500",
            transmisi: "Manual",
            harga: 145000000,
          },
          {
            tahun: "2019",
            tipe: "G",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 150000000,
          },
          {
            tahun: "2019",
            tipe: "VELOZ",
            mesin: "1500",
            transmisi: "Manual",
            harga: 155000000,
          },
          {
            tahun: "2019",
            tipe: "VELOZ",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 160000000,
          },
          {
            tahun: "2020",
            tipe: "E",
            mesin: "1300",
            transmisi: "Manual",
            harga: 130000000,
          },
          {
            tahun: "2020",
            tipe: "E",
            mesin: "1300",
            transmisi: "Automatic",
            harga: 135000000,
          },
          {
            tahun: "2020",
            tipe: "G",
            mesin: "1300",
            transmisi: "Manual",
            harga: 140000000,
          },
          {
            tahun: "2020",
            tipe: "G",
            mesin: "1300",
            transmisi: "Automatic",
            harga: 145000000,
          },
          {
            tahun: "2020",
            tipe: "G",
            mesin: "1500",
            transmisi: "Manual",
            harga: 150000000,
          },
          {
            tahun: "2020",
            tipe: "G",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 155000000,
          },
          {
            tahun: "2020",
            tipe: "VELOZ",
            mesin: "1500",
            transmisi: "Manual",
            harga: 160000000,
          },
          {
            tahun: "2020",
            tipe: "VELOZ",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 165000000,
          },
        ],
      },
      {
        detail_merek: "CALYA",
        detail_spek: [
          {
            tahun: "2016",
            tipe: "E",
            mesin: "1200",
            transmisi: "Manual",
            harga: 90000000,
          },
          {
            tahun: "2016",
            tipe: "G",
            mesin: "1200",
            transmisi: "Manual",
            harga: 110000000,
          },
          {
            tahun: "2016",
            tipe: "G",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 115000000,
          },
          {
            tahun: "2017",
            tipe: "E",
            mesin: "1200",
            transmisi: "Manual",
            harga: 95000000,
          },
          {
            tahun: "2017",
            tipe: "E",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 100000000,
          },
          {
            tahun: "2017",
            tipe: "G",
            mesin: "1200",
            transmisi: "Manual",
            harga: 110000000,
          },
          {
            tahun: "2017",
            tipe: "G",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 115000000,
          },
          {
            tahun: "2018",
            tipe: "E",
            mesin: "1200",
            transmisi: "Manual",
            harga: 100000000,
          },
          {
            tahun: "2018",
            tipe: "E",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 105000000,
          },
          {
            tahun: "2018",
            tipe: "G",
            mesin: "1200",
            transmisi: "Manual",
            harga: 110000000,
          },
          {
            tahun: "2018",
            tipe: "G",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 115000000,
          },
          {
            tahun: "2019",
            tipe: "E",
            mesin: "1200",
            transmisi: "Manual",
            harga: 105000000,
          },
          {
            tahun: "2019",
            tipe: "E",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 110000000,
          },
          {
            tahun: "2019",
            tipe: "G",
            mesin: "1200",
            transmisi: "Manual",
            harga: 115000000,
          },
          {
            tahun: "2019",
            tipe: "G",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 125000000,
          },
          {
            tahun: "2020",
            tipe: "E",
            mesin: "1200",
            transmisi: "Manual",
            harga: 110000000,
          },
          {
            tahun: "2020",
            tipe: "E",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 115000000,
          },
          {
            tahun: "2020",
            tipe: "G",
            mesin: "1200",
            transmisi: "Manual",
            harga: 120000000,
          },
          {
            tahun: "2020",
            tipe: "G",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 130000000,
          },
        ],
      },
      {
        detail_merek: "FORTUNER",
        detail_spek: [
          {
            tahun: "2015",
            tipe: "G",
            mesin: "2500",
            transmisi: "Manual",
            harga: 250000000,
          },
          {
            tahun: "2015",
            tipe: "G",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 280000000,
          },
          {
            tahun: "2015",
            tipe: "G TRD",
            mesin: "2500",
            transmisi: "Manual",
            harga: 300000000,
          },
          {
            tahun: "2015",
            tipe: "G TRD",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 320000000,
          },
          {
            tahun: "2016",
            tipe: "G",
            mesin: "2400",
            transmisi: "Manual",
            harga: 360000000,
          },
          {
            tahun: "2016",
            tipe: "G",
            mesin: "2400",
            transmisi: "Automatic",
            harga: 360000000,
          },
          {
            tahun: "2016",
            tipe: "SRZ",
            mesin: "2700",
            transmisi: "Automatic",
            harga: 400000000,
          },
          {
            tahun: "2016",
            tipe: "VRZ",
            mesin: "2400",
            transmisi: "Automatic",
            harga: 410000000,
          },
          {
            tahun: "2017",
            tipe: "G",
            mesin: "2400",
            transmisi: "Manual",
            harga: 370000000,
          },
          {
            tahun: "2017",
            tipe: "G",
            mesin: "2400",
            transmisi: "Automatic",
            harga: 370000000,
          },
          {
            tahun: "2017",
            tipe: "SRZ",
            mesin: "2700",
            transmisi: "Automatic",
            harga: 430000000,
          },
          {
            tahun: "2017",
            tipe: "VRZ",
            mesin: "2400",
            transmisi: "Automatic",
            harga: 440000000,
          },
          {
            tahun: "2018",
            tipe: "G",
            mesin: "2400",
            transmisi: "Manual",
            harga: 390000000,
          },
          {
            tahun: "2018",
            tipe: "G",
            mesin: "2400",
            transmisi: "Automatic",
            harga: 390000000,
          },
          {
            tahun: "2018",
            tipe: "SRZ",
            mesin: "2700",
            transmisi: "Automatic",
            harga: 450000000,
          },
          {
            tahun: "2018",
            tipe: "TRD",
            mesin: "2400",
            transmisi: "Automatic",
            harga: 460000000,
          },
          {
            tahun: "2019",
            tipe: "G",
            mesin: "2400",
            transmisi: "Manual",
            harga: 410000000,
          },
          {
            tahun: "2019",
            tipe: "G",
            mesin: "2400",
            transmisi: "Automatic",
            harga: 410000000,
          },
          {
            tahun: "2019",
            tipe: "SRZ",
            mesin: "2700",
            transmisi: "Automatic",
            harga: 470000000,
          },
          {
            tahun: "2019",
            tipe: "SRZ TRD",
            mesin: "2700",
            transmisi: "Automatic",
            harga: 480000000,
          },
          {
            tahun: "2019",
            tipe: "VRZ",
            mesin: "2400",
            transmisi: "Automatic",
            harga: 480000000,
          },
          {
            tahun: "2019",
            tipe: "VRZ TRD",
            mesin: "2400",
            transmisi: "Automatic",
            harga: 490000000,
          },
          {
            tahun: "2020",
            tipe: "G",
            mesin: "2400",
            transmisi: "Manual",
            harga: 430000000,
          },
          {
            tahun: "2020",
            tipe: "G",
            mesin: "2400",
            transmisi: "Automatic",
            harga: 430000000,
          },
          {
            tahun: "2020",
            tipe: "SRZ",
            mesin: "2700",
            transmisi: "Automatic",
            harga: 490000000,
          },
          {
            tahun: "2020",
            tipe: "SRZ TRD",
            mesin: "2700",
            transmisi: "Automatic",
            harga: 500000000,
          },
          {
            tahun: "2020",
            tipe: "VRZ",
            mesin: "2400",
            transmisi: "Automatic",
            harga: 500000000,
          },
          {
            tahun: "2020",
            tipe: "VRZ TRD",
            mesin: "2400",
            transmisi: "Automatic",
            harga: 510000000,
          },
        ],
      },
      {
        detail_merek: "KIJANG INNOVA",
        detail_spek: [
          {
            tahun: "2015",
            tipe: "E",
            mesin: "2000",
            transmisi: "Manual",
            harga: 170000000,
          },
          {
            tahun: "2015",
            tipe: "E",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 160000000,
          },
          {
            tahun: "2015",
            tipe: "E",
            mesin: "2500",
            transmisi: "Manual",
            harga: 220000000,
          },
          {
            tahun: "2015",
            tipe: "G",
            mesin: "2000",
            transmisi: "Manual",
            harga: 200000000,
          },
          {
            tahun: "2015",
            tipe: "G",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 200000000,
          },
          {
            tahun: "2015",
            tipe: "G",
            mesin: "2500",
            transmisi: "Manual",
            harga: 240000000,
          },
          {
            tahun: "2015",
            tipe: "G",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 240000000,
          },
          {
            tahun: "2015",
            tipe: "J",
            mesin: "2000",
            transmisi: "Manual",
            harga: 150000000,
          },
          {
            tahun: "2015",
            tipe: "V",
            mesin: "2000",
            transmisi: "Manual",
            harga: 200000000,
          },
          {
            tahun: "2015",
            tipe: "V",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 200000000,
          },
          {
            tahun: "2015",
            tipe: "V",
            mesin: "2500",
            transmisi: "Manual",
            harga: 260000000,
          },
          {
            tahun: "2015",
            tipe: "V",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 250000000,
          },
          {
            tahun: "2015",
            tipe: "V LUX",
            mesin: "2000",
            transmisi: "Manual",
            harga: 220000000,
          },
          {
            tahun: "2015",
            tipe: "V LUX",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 210000000,
          },
          {
            tahun: "2016",
            tipe: "G",
            mesin: "2000",
            transmisi: "Manual",
            harga: 220000000,
          },
          {
            tahun: "2016",
            tipe: "G",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 230000000,
          },
          {
            tahun: "2016",
            tipe: "G",
            mesin: "2400",
            transmisi: "Manual",
            harga: 270000000,
          },
          {
            tahun: "2016",
            tipe: "G",
            mesin: "2400",
            transmisi: "Automatic",
            harga: 280000000,
          },
          {
            tahun: "2016",
            tipe: "G LUX",
            mesin: "2000",
            transmisi: "Manual",
            harga: 230000000,
          },
          {
            tahun: "2016",
            tipe: "Q",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 280000000,
          },
          {
            tahun: "2016",
            tipe: "Q",
            mesin: "2400",
            transmisi: "Automatic",
            harga: 360000000,
          },
          {
            tahun: "2016",
            tipe: "Q LUX",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 300000000,
          },
          {
            tahun: "2016",
            tipe: "V",
            mesin: "2000",
            transmisi: "Manual",
            harga: 240000000,
          },
          {
            tahun: "2016",
            tipe: "V",
            mesin: "2400",
            transmisi: "Manual",
            harga: 300000000,
          },
          {
            tahun: "2016",
            tipe: "V",
            mesin: "2400",
            transmisi: "Automatic",
            harga: 320000000,
          },
          {
            tahun: "2017",
            tipe: "G",
            mesin: "2000",
            transmisi: "Manual",
            harga: 230000000,
          },
          {
            tahun: "2017",
            tipe: "G",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 240000000,
          },
          {
            tahun: "2017",
            tipe: "G",
            mesin: "2400",
            transmisi: "Manual",
            harga: 290000000,
          },
          {
            tahun: "2017",
            tipe: "G",
            mesin: "2400",
            transmisi: "Automatic",
            harga: 290000000,
          },
          {
            tahun: "2017",
            tipe: "G LUX",
            mesin: "2000",
            transmisi: "Manual",
            harga: 240000000,
          },
          {
            tahun: "2017",
            tipe: "Q",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 285000000,
          },
          {
            tahun: "2017",
            tipe: "V",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 260000000,
          },
          {
            tahun: "2017",
            tipe: "V",
            mesin: "2400",
            transmisi: "Manual",
            harga: 320000000,
          },
          {
            tahun: "2017",
            tipe: "V",
            mesin: "2400",
            transmisi: "Automatic",
            harga: 340000000,
          },
          {
            tahun: "2017",
            tipe: "VENTURER",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 300000000,
          },
          {
            tahun: "2017",
            tipe: "VENTURER",
            mesin: "2400",
            transmisi: "Automatic",
            harga: 380000000,
          },
          {
            tahun: "2018",
            tipe: "G",
            mesin: "2000",
            transmisi: "Manual",
            harga: 240000000,
          },
          {
            tahun: "2018",
            tipe: "G",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 250000000,
          },
          {
            tahun: "2018",
            tipe: "G",
            mesin: "2400",
            transmisi: "Manual",
            harga: 310000000,
          },
          {
            tahun: "2018",
            tipe: "G",
            mesin: "2400",
            transmisi: "Automatic",
            harga: 310000000,
          },
          {
            tahun: "2018",
            tipe: "G LUX",
            mesin: "2000",
            transmisi: "Manual",
            harga: 250000000,
          },
          {
            tahun: "2018",
            tipe: "V",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 280000000,
          },
          {
            tahun: "2018",
            tipe: "V",
            mesin: "2400",
            transmisi: "Manual",
            harga: 340000000,
          },
          {
            tahun: "2018",
            tipe: "V",
            mesin: "2400",
            transmisi: "Automatic",
            harga: 350000000,
          },
          {
            tahun: "2018",
            tipe: "VENTURER",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 310000000,
          },
          {
            tahun: "2018",
            tipe: "VENTURER",
            mesin: "2400",
            transmisi: "Automatic",
            harga: 390000000,
          },
          {
            tahun: "2019",
            tipe: "G",
            mesin: "2000",
            transmisi: "Manual",
            harga: 250000000,
          },
          {
            tahun: "2019",
            tipe: "G",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 260000000,
          },
          {
            tahun: "2019",
            tipe: "G",
            mesin: "2400",
            transmisi: "Manual",
            harga: 320000000,
          },
          {
            tahun: "2019",
            tipe: "G",
            mesin: "2400",
            transmisi: "Automatic",
            harga: 320000000,
          },
          {
            tahun: "2019",
            tipe: "G LUX",
            mesin: "2000",
            transmisi: "Manual",
            harga: 260000000,
          },
          {
            tahun: "2019",
            tipe: "V",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 290000000,
          },
          {
            tahun: "2019",
            tipe: "V",
            mesin: "2400",
            transmisi: "Manual",
            harga: 350000000,
          },
          {
            tahun: "2019",
            tipe: "V",
            mesin: "2400",
            transmisi: "Automatic",
            harga: 360000000,
          },
          {
            tahun: "2019",
            tipe: "VENTURER",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 320000000,
          },
          {
            tahun: "2019",
            tipe: "VENTURER",
            mesin: "2400",
            transmisi: "Automatic",
            harga: 400000000,
          },
          {
            tahun: "2020",
            tipe: "G",
            mesin: "2000",
            transmisi: "Manual",
            harga: 260000000,
          },
          {
            tahun: "2020",
            tipe: "G",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 270000000,
          },
          {
            tahun: "2020",
            tipe: "G",
            mesin: "2400",
            transmisi: "Manual",
            harga: 330000000,
          },
          {
            tahun: "2020",
            tipe: "G",
            mesin: "2400",
            transmisi: "Automatic",
            harga: 330000000,
          },
          {
            tahun: "2020",
            tipe: "G LUX",
            mesin: "2000",
            transmisi: "Manual",
            harga: 270000000,
          },
          {
            tahun: "2020",
            tipe: "V",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 300000000,
          },
          {
            tahun: "2020",
            tipe: "V",
            mesin: "2400",
            transmisi: "Manual",
            harga: 360000000,
          },
          {
            tahun: "2020",
            tipe: "V",
            mesin: "2400",
            transmisi: "Automatic",
            harga: 370000000,
          },
          {
            tahun: "2020",
            tipe: "VENTURER",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 330000000,
          },
          {
            tahun: "2020",
            tipe: "VENTURER",
            mesin: "2400",
            transmisi: "Automatic",
            harga: 410000000,
          },
        ],
      },
      {
        detail_merek: "RUSH",
        detail_spek: [
          {
            tahun: "2015",
            tipe: "G",
            mesin: "1500",
            transmisi: "Manual",
            harga: 140000000,
          },
          {
            tahun: "2015",
            tipe: "G",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 145000000,
          },
          {
            tahun: "2015",
            tipe: "S",
            mesin: "1500",
            transmisi: "Manual",
            harga: 145000000,
          },
          {
            tahun: "2015",
            tipe: "S",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 150000000,
          },
          {
            tahun: "2015",
            tipe: "TRD",
            mesin: "1500",
            transmisi: "Manual",
            harga: 150000000,
          },
          {
            tahun: "2015",
            tipe: "TRD",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 155000000,
          },
          {
            tahun: "2016",
            tipe: "G",
            mesin: "1500",
            transmisi: "Manual",
            harga: 145000000,
          },
          {
            tahun: "2016",
            tipe: "G",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 150000000,
          },
          {
            tahun: "2016",
            tipe: "S",
            mesin: "1500",
            transmisi: "Manual",
            harga: 155000000,
          },
          {
            tahun: "2016",
            tipe: "S",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 160000000,
          },
          {
            tahun: "2016",
            tipe: "TRD",
            mesin: "1500",
            transmisi: "Manual",
            harga: 165000000,
          },
          {
            tahun: "2016",
            tipe: "TRD",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 170000000,
          },
          {
            tahun: "2017",
            tipe: "G",
            mesin: "1500",
            transmisi: "Manual",
            harga: 150000000,
          },
          {
            tahun: "2017",
            tipe: "G",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 155000000,
          },
          {
            tahun: "2017",
            tipe: "S",
            mesin: "1500",
            transmisi: "Manual",
            harga: 160000000,
          },
          {
            tahun: "2017",
            tipe: "S",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 165000000,
          },
          {
            tahun: "2017",
            tipe: "TRD",
            mesin: "1500",
            transmisi: "Manual",
            harga: 170000000,
          },
          {
            tahun: "2017",
            tipe: "TRD",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 175000000,
          },
          {
            tahun: "2018",
            tipe: "G",
            mesin: "1500",
            transmisi: "Manual",
            harga: 155000000,
          },
          {
            tahun: "2018",
            tipe: "G",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 160000000,
          },
          {
            tahun: "2018",
            tipe: "TRD",
            mesin: "1500",
            transmisi: "Manual",
            harga: 175000000,
          },
          {
            tahun: "2018",
            tipe: "TRD",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 180000000,
          },
          {
            tahun: "2019",
            tipe: "G",
            mesin: "1500",
            transmisi: "Manual",
            harga: 165000000,
          },
          {
            tahun: "2019",
            tipe: "G",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 170000000,
          },
          {
            tahun: "2019",
            tipe: "TRD",
            mesin: "1500",
            transmisi: "Manual",
            harga: 18000000,
          },
          {
            tahun: "2019",
            tipe: "TRD",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 185000000,
          },
          {
            tahun: "2020",
            tipe: "G",
            mesin: "1500",
            transmisi: "Manual",
            harga: 175000000,
          },
          {
            tahun: "2020",
            tipe: "G",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 180000000,
          },
          {
            tahun: "2020",
            tipe: "TRD",
            mesin: "1500",
            transmisi: "Manual",
            harga: 19000000,
          },
          {
            tahun: "2020",
            tipe: "TRD",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 195000000,
          },
        ],
      },
      {
        detail_merek: "YARIS",
        detail_spek: [
          {
            tahun: "2015",
            tipe: "E",
            mesin: "1500",
            transmisi: "Manual",
            harga: 140000000,
          },
          {
            tahun: "2015",
            tipe: "E",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 150000000,
          },
          {
            tahun: "2015",
            tipe: "G",
            mesin: "1500",
            transmisi: "Manual",
            harga: 150000000,
          },
          {
            tahun: "2015",
            tipe: "G",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 160000000,
          },
          {
            tahun: "2015",
            tipe: "TRD SPORTIVO",
            mesin: "1500",
            transmisi: "Manual",
            harga: 170000000,
          },
          {
            tahun: "2015",
            tipe: "TRD SPORTIVO",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 175000000,
          },
          {
            tahun: "2016",
            tipe: "E",
            mesin: "1500",
            transmisi: "Manual",
            harga: 150000000,
          },
          {
            tahun: "2016",
            tipe: "E",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 160000000,
          },
          {
            tahun: "2016",
            tipe: "G",
            mesin: "1500",
            transmisi: "Manual",
            harga: 160000000,
          },
          {
            tahun: "2016",
            tipe: "G",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 170000000,
          },
          {
            tahun: "2016",
            tipe: "TRD SPORTIVO",
            mesin: "1500",
            transmisi: "Manual",
            harga: 180000000,
          },
          {
            tahun: "2016",
            tipe: "TRD SPORTIVO",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 190000000,
          },
          {
            tahun: "2017",
            tipe: "E",
            mesin: "1500",
            transmisi: "Manual",
            harga: 170000000,
          },
          {
            tahun: "2017",
            tipe: "E",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 180000000,
          },
          {
            tahun: "2017",
            tipe: "G",
            mesin: "1500",
            transmisi: "Manual",
            harga: 180000000,
          },
          {
            tahun: "2017",
            tipe: "G",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 185000000,
          },
          {
            tahun: "2017",
            tipe: "S TRD",
            mesin: "1500",
            transmisi: "Manual",
            harga: 205000000,
          },
          {
            tahun: "2017",
            tipe: "S TRD",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 210000000,
          },
          {
            tahun: "2017",
            tipe: "S TRD HEYKERS",
            mesin: "1500",
            transmisi: "Manual",
            harga: 220000000,
          },
          {
            tahun: "2017",
            tipe: "S TRD HEYKERS",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 220000000,
          },
          {
            tahun: "2018",
            tipe: "E",
            mesin: "1500",
            transmisi: "Manual",
            harga: 180000000,
          },
          {
            tahun: "2018",
            tipe: "E",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 190000000,
          },
          {
            tahun: "2018",
            tipe: "G",
            mesin: "1500",
            transmisi: "Manual",
            harga: 190000000,
          },
          {
            tahun: "2018",
            tipe: "G",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 225000000,
          },
          {
            tahun: "2018",
            tipe: "S TRD",
            mesin: "1500",
            transmisi: "Manual",
            harga: 210000000,
          },
          {
            tahun: "2018",
            tipe: "S TRD",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 230000000,
          },
          {
            tahun: "2018",
            tipe: "S TRD HEYKERS",
            mesin: "1500",
            transmisi: "Manual",
            harga: 230000000,
          },
          {
            tahun: "2018",
            tipe: "S TRD HEYKERS",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 250000000,
          },
          {
            tahun: "2019",
            tipe: "E",
            mesin: "1500",
            transmisi: "Manual",
            harga: 190000000,
          },
          {
            tahun: "2019",
            tipe: "E",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 200000000,
          },
          {
            tahun: "2019",
            tipe: "G",
            mesin: "1500",
            transmisi: "Manual",
            harga: 200000000,
          },
          {
            tahun: "2019",
            tipe: "G",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 230000000,
          },
          {
            tahun: "2019",
            tipe: "S TRD",
            mesin: "1500",
            transmisi: "Manual",
            harga: 220000000,
          },
          {
            tahun: "2019",
            tipe: "S TRD",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 240000000,
          },
          {
            tahun: "2020",
            tipe: "G",
            mesin: "1500",
            transmisi: "Manual",
            harga: 210000000,
          },
          {
            tahun: "2020",
            tipe: "G",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 240000000,
          },
          {
            tahun: "2020",
            tipe: "S TRD",
            mesin: "1500",
            transmisi: "Manual",
            harga: 230000000,
          },
          {
            tahun: "2020",
            tipe: "S TRD",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 250000000,
          },
        ],
      },
    ],
  },
  {
    merek: "Daihatsu",
    detail: [
      {
        detail_merek: "AYLA",
        detail_spek: [
          {
            tahun: "2015",
            tipe: "D",
            mesin: "1000",
            transmisi: "Manual",
            harga: 65000000,
          },
          {
            tahun: "2015",
            tipe: "M",
            mesin: "1000",
            transmisi: "Manual",
            harga: 70000000,
          },
          {
            tahun: "2015",
            tipe: "M",
            mesin: "1000",
            transmisi: "Automatic",
            harga: 70000000,
          },
          {
            tahun: "2015",
            tipe: "X",
            mesin: "1000",
            transmisi: "Manual",
            harga: 75000000,
          },
          {
            tahun: "2015",
            tipe: "X",
            mesin: "1000",
            transmisi: "Automatic",
            harga: 75000000,
          },
          {
            tahun: "2016",
            tipe: "D",
            mesin: "1000",
            transmisi: "Manual",
            harga: 70000000,
          },
          {
            tahun: "2016",
            tipe: "M",
            mesin: "1000",
            transmisi: "Manual",
            harga: 75000000,
          },
          {
            tahun: "2016",
            tipe: "M",
            mesin: "1000",
            transmisi: "Automatic",
            harga: 75000000,
          },
          {
            tahun: "2016",
            tipe: "X",
            mesin: "1000",
            transmisi: "Manual",
            harga: 80000000,
          },
          {
            tahun: "2016",
            tipe: "X",
            mesin: "1000",
            transmisi: "Automatic",
            harga: 80000000,
          },
          {
            tahun: "2017",
            tipe: "D",
            mesin: "1000",
            transmisi: "Manual",
            harga: 75000000,
          },
          {
            tahun: "2017",
            tipe: "M",
            mesin: "1000",
            transmisi: "Manual",
            harga: 80000000,
          },
          {
            tahun: "2017",
            tipe: "M",
            mesin: "1000",
            transmisi: "Automatic",
            harga: 80000000,
          },
          {
            tahun: "2017",
            tipe: "X",
            mesin: "1000",
            transmisi: "Manual",
            harga: 85000000,
          },
          {
            tahun: "2017",
            tipe: "X",
            mesin: "1000",
            transmisi: "Automatic",
            harga: 85000000,
          },
          {
            tahun: "2017",
            tipe: "R",
            mesin: "1200",
            transmisi: "Manual",
            harga: 90000000,
          },
          {
            tahun: "2017",
            tipe: "R",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 95000000,
          },
          {
            tahun: "2017",
            tipe: "R DELUXE",
            mesin: "1200",
            transmisi: "Manual",
            harga: 90000000,
          },
          {
            tahun: "2017",
            tipe: "R DELUXE",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 95000000,
          },
          {
            tahun: "2018",
            tipe: "D",
            mesin: "1000",
            transmisi: "Manual",
            harga: 80000000,
          },
          {
            tahun: "2018",
            tipe: "M",
            mesin: "1000",
            transmisi: "Manual",
            harga: 85000000,
          },
          {
            tahun: "2018",
            tipe: "M",
            mesin: "1000",
            transmisi: "Automatic",
            harga: 85000000,
          },
          {
            tahun: "2018",
            tipe: "X",
            mesin: "1200",
            transmisi: "Manual",
            harga: 90000000,
          },
          {
            tahun: "2018",
            tipe: "X",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 95000000,
          },
          {
            tahun: "2018",
            tipe: "R",
            mesin: "1200",
            transmisi: "Manual",
            harga: 95000000,
          },
          {
            tahun: "2018",
            tipe: "R",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 100000000,
          },
          {
            tahun: "2018",
            tipe: "R DELUXE",
            mesin: "1200",
            transmisi: "Manual",
            harga: 100000000,
          },
          {
            tahun: "2018",
            tipe: "R DELUXE",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 100000000,
          },
          {
            tahun: "2019",
            tipe: "D",
            mesin: "1000",
            transmisi: "Manual",
            harga: 85000000,
          },
          {
            tahun: "2019",
            tipe: "M",
            mesin: "1000",
            transmisi: "Manual",
            harga: 90000000,
          },
          {
            tahun: "2019",
            tipe: "M",
            mesin: "1000",
            transmisi: "Automatic",
            harga: 90000000,
          },
          {
            tahun: "2019",
            tipe: "X",
            mesin: "1200",
            transmisi: "Manual",
            harga: 95000000,
          },
          {
            tahun: "2019",
            tipe: "X",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 100000000,
          },
          {
            tahun: "2019",
            tipe: "R",
            mesin: "1200",
            transmisi: "Manual",
            harga: 100000000,
          },
          {
            tahun: "2019",
            tipe: "R",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 105000000,
          },
          {
            tahun: "2019",
            tipe: "R DELUXE",
            mesin: "1200",
            transmisi: "Manual",
            harga: 105000000,
          },
          {
            tahun: "2019",
            tipe: "R DELUXE",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 105000000,
          },
          {
            tahun: "2020",
            tipe: "D",
            mesin: "1000",
            transmisi: "Manual",
            harga: 90000000,
          },
          {
            tahun: "2020",
            tipe: "M",
            mesin: "1000",
            transmisi: "Manual",
            harga: 95000000,
          },
          {
            tahun: "2020",
            tipe: "M",
            mesin: "1000",
            transmisi: "Automatic",
            harga: 100000000,
          },
          {
            tahun: "2020",
            tipe: "X",
            mesin: "1200",
            transmisi: "Manual",
            harga: 100000000,
          },
          {
            tahun: "2020",
            tipe: "X",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 105000000,
          },
          {
            tahun: "2020",
            tipe: "R",
            mesin: "1200",
            transmisi: "Manual",
            harga: 105000000,
          },
          {
            tahun: "2020",
            tipe: "R",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 110000000,
          },
          {
            tahun: "2020",
            tipe: "R DELUXE",
            mesin: "1200",
            transmisi: "Manual",
            harga: 110000000,
          },
          {
            tahun: "2020",
            tipe: "R DELUXE",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 115000000,
          },
        ],
      },
      {
        detail_merek: "SIGRA",
        detail_spek: [
          {
            tahun: "2016",
            tipe: "D",
            mesin: "1000",
            transmisi: "Manual",
            harga: 65000000,
          },
          {
            tahun: "2016",
            tipe: "M",
            mesin: "1000",
            transmisi: "Manual",
            harga: 70000000,
          },
          {
            tahun: "2016",
            tipe: "X",
            mesin: "1200",
            transmisi: "Manual",
            harga: 75000000,
          },
          {
            tahun: "2016",
            tipe: "X",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 80000000,
          },
          {
            tahun: "2016",
            tipe: "X DELUXE",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 80000000,
          },
          {
            tahun: "2016",
            tipe: "R DELUXE",
            mesin: "1200",
            transmisi: "Manual",
            harga: 75000000,
          },
          {
            tahun: "2016",
            tipe: "R DELUXE",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 80000000,
          },
          {
            tahun: "2017",
            tipe: "D",
            mesin: "1000",
            transmisi: "Manual",
            harga: 70000000,
          },
          {
            tahun: "2017",
            tipe: "M",
            mesin: "1000",
            transmisi: "Manual",
            harga: 75000000,
          },
          {
            tahun: "2017",
            tipe: "X",
            mesin: "1200",
            transmisi: "Manual",
            harga: 80000000,
          },
          {
            tahun: "2017",
            tipe: "X",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 85000000,
          },
          {
            tahun: "2017",
            tipe: "X DELUXE",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 85000000,
          },
          {
            tahun: "2017",
            tipe: "R DELUXE",
            mesin: "1200",
            transmisi: "Manual",
            harga: 80000000,
          },
          {
            tahun: "2017",
            tipe: "R DELUXE",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 85000000,
          },
          {
            tahun: "2018",
            tipe: "D",
            mesin: "1000",
            transmisi: "Manual",
            harga: 75000000,
          },
          {
            tahun: "2018",
            tipe: "M",
            mesin: "1000",
            transmisi: "Manual",
            harga: 80000000,
          },
          {
            tahun: "2018",
            tipe: "X",
            mesin: "1200",
            transmisi: "Manual",
            harga: 85000000,
          },
          {
            tahun: "2018",
            tipe: "X",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 90000000,
          },
          {
            tahun: "2018",
            tipe: "X DELUXE",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 90000000,
          },
          {
            tahun: "2018",
            tipe: "R DELUXE",
            mesin: "1200",
            transmisi: "Manual",
            harga: 85000000,
          },
          {
            tahun: "2018",
            tipe: "R DELUXE",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 90000000,
          },
          {
            tahun: "2019",
            tipe: "D",
            mesin: "1000",
            transmisi: "Manual",
            harga: 80000000,
          },
          {
            tahun: "2019",
            tipe: "M",
            mesin: "1000",
            transmisi: "Manual",
            harga: 85000000,
          },
          {
            tahun: "2019",
            tipe: "X",
            mesin: "1200",
            transmisi: "Manual",
            harga: 90000000,
          },
          {
            tahun: "2019",
            tipe: "X",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 95000000,
          },
          {
            tahun: "2019",
            tipe: "X DELUXE",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 95000000,
          },
          {
            tahun: "2019",
            tipe: "R DELUXE",
            mesin: "1200",
            transmisi: "Manual",
            harga: 100000000,
          },
          {
            tahun: "2019",
            tipe: "R DELUXE",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 100000000,
          },
          {
            tahun: "2020",
            tipe: "D",
            mesin: "1000",
            transmisi: "Manual",
            harga: 85000000,
          },
          {
            tahun: "2020",
            tipe: "M",
            mesin: "1000",
            transmisi: "Manual",
            harga: 90000000,
          },
          {
            tahun: "2020",
            tipe: "X",
            mesin: "1200",
            transmisi: "Manual",
            harga: 95000000,
          },
          {
            tahun: "2020",
            tipe: "X",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 100000000,
          },
          {
            tahun: "2020",
            tipe: "X DELUXE",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 100000000,
          },
          {
            tahun: "2020",
            tipe: "R DELUXE",
            mesin: "1200",
            transmisi: "Manual",
            harga: 105000000,
          },
          {
            tahun: "2020",
            tipe: "R DELUXE",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 110000000,
          },
        ],
      },
      {
        detail_merek: "TERIOS",
        detail_spek: [
          {
            tahun: "2015",
            tipe: "X",
            mesin: "1500",
            transmisi: "Manual",
            harga: 135000000,
          },
          {
            tahun: "2015",
            tipe: "R",
            mesin: "1500",
            transmisi: "Manual",
            harga: 150000000,
          },
          {
            tahun: "2015",
            tipe: "R",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 160000000,
          },
          {
            tahun: "2016",
            tipe: "X",
            mesin: "1500",
            transmisi: "Manual",
            harga: 145000000,
          },
          {
            tahun: "2016",
            tipe: "R",
            mesin: "1500",
            transmisi: "Manual",
            harga: 160000000,
          },
          {
            tahun: "2016",
            tipe: "R",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 170000000,
          },
          {
            tahun: "2017",
            tipe: "X",
            mesin: "1500",
            transmisi: "Manual",
            harga: 155000000,
          },
          {
            tahun: "2017",
            tipe: "R",
            mesin: "1500",
            transmisi: "Manual",
            harga: 170000000,
          },
          {
            tahun: "2017",
            tipe: "R",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 180000000,
          },
          {
            tahun: "2018",
            tipe: "X",
            mesin: "1500",
            transmisi: "Manual",
            harga: 130000000,
          },
          {
            tahun: "2018",
            tipe: "X",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 150000000,
          },
          {
            tahun: "2018",
            tipe: "R",
            mesin: "1500",
            transmisi: "Manual",
            harga: 190000000,
          },
          {
            tahun: "2018",
            tipe: "R",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 195000000,
          },
          {
            tahun: "2018",
            tipe: "R DELUXE",
            mesin: "1500",
            transmisi: "Manual",
            harga: 200000000,
          },
          {
            tahun: "2018",
            tipe: "R DELUXE",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 215000000,
          },
          {
            tahun: "2019",
            tipe: "X",
            mesin: "1500",
            transmisi: "Manual",
            harga: 170000000,
          },
          {
            tahun: "2019",
            tipe: "X",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 180000000,
          },
          {
            tahun: "2019",
            tipe: "X DELUXE",
            mesin: "1500",
            transmisi: "Manual",
            harga: 190000000,
          },
          {
            tahun: "2019",
            tipe: "X DELUXE",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 210000000,
          },
          {
            tahun: "2019",
            tipe: "R",
            mesin: "1500",
            transmisi: "Manual",
            harga: 200000000,
          },
          {
            tahun: "2019",
            tipe: "R",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 210000000,
          },
          {
            tahun: "2019",
            tipe: "R DELUXE",
            mesin: "1500",
            transmisi: "Manual",
            harga: 205000000,
          },
          {
            tahun: "2019",
            tipe: "R DELUXE",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 225000000,
          },
          {
            tahun: "2020",
            tipe: "X",
            mesin: "1500",
            transmisi: "Manual",
            harga: 180000000,
          },
          {
            tahun: "2020",
            tipe: "X",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 190000000,
          },
          {
            tahun: "2020",
            tipe: "X DELUXE",
            mesin: "1500",
            transmisi: "Manual",
            harga: 200000000,
          },
          {
            tahun: "2020",
            tipe: "X DELUXE",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 220000000,
          },
          {
            tahun: "2020",
            tipe: "R",
            mesin: "1500",
            transmisi: "Manual",
            harga: 210000000,
          },
          {
            tahun: "2020",
            tipe: "R",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 220000000,
          },
          {
            tahun: "2020",
            tipe: "R DELUXE",
            mesin: "1500",
            transmisi: "Manual",
            harga: 215000000,
          },
          {
            tahun: "2020",
            tipe: "R DELUXE",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 235000000,
          },
        ],
      },
      {
        detail_merek: "XENIA",
        detail_spek: [
          {
            tahun: "2015",
            tipe: "D",
            mesin: "1000",
            transmisi: "Manual",
            harga: 105000000,
          },
          {
            tahun: "2015",
            tipe: "M",
            mesin: "1000",
            transmisi: "Manual",
            harga: 105000000,
          },
          {
            tahun: "2015",
            tipe: "X",
            mesin: "1300",
            transmisi: "Manual",
            harga: 115000000,
          },
          {
            tahun: "2015",
            tipe: "X",
            mesin: "1300",
            transmisi: "Automatic",
            harga: 120000000,
          },
          {
            tahun: "2015",
            tipe: "R",
            mesin: "1300",
            transmisi: "Manual",
            harga: 125000000,
          },
          {
            tahun: "2015",
            tipe: "R",
            mesin: "1300",
            transmisi: "Automatic",
            harga: 125000000,
          },
          {
            tahun: "2015",
            tipe: "R ATTIVO",
            mesin: "1300",
            transmisi: "Manual",
            harga: 130000000,
          },
          {
            tahun: "2015",
            tipe: "R ATTIVO",
            mesin: "1300",
            transmisi: "Automatic",
            harga: 130000000,
          },
          {
            tahun: "2016",
            tipe: "D",
            mesin: "1000",
            transmisi: "Manual",
            harga: 110000000,
          },
          {
            tahun: "2016",
            tipe: "M",
            mesin: "1000",
            transmisi: "Manual",
            harga: 115000000,
          },
          {
            tahun: "2016",
            tipe: "X",
            mesin: "1300",
            transmisi: "Manual",
            harga: 125000000,
          },
          {
            tahun: "2016",
            tipe: "X",
            mesin: "1300",
            transmisi: "Automatic",
            harga: 130000000,
          },
          {
            tahun: "2016",
            tipe: "R",
            mesin: "1300",
            transmisi: "Manual",
            harga: 135000000,
          },
          {
            tahun: "2016",
            tipe: "R",
            mesin: "1300",
            transmisi: "Automatic",
            harga: 135000000,
          },
          {
            tahun: "2016",
            tipe: "R ATTIVO",
            mesin: "1300",
            transmisi: "Manual",
            harga: 140000000,
          },
          {
            tahun: "2016",
            tipe: "R ATTIVO",
            mesin: "1300",
            transmisi: "Automatic",
            harga: 140000000,
          },
          {
            tahun: "2017",
            tipe: "D",
            mesin: "1000",
            transmisi: "Manual",
            harga: 115000000,
          },
          {
            tahun: "2017",
            tipe: "D",
            mesin: "1000",
            transmisi: "Automatic",
            harga: 120000000,
          },
          {
            tahun: "2017",
            tipe: "M",
            mesin: "1000",
            transmisi: "Manual",
            harga: 125000000,
          },
          {
            tahun: "2017",
            tipe: "M",
            mesin: "1000",
            transmisi: "Automatic",
            harga: 130000000,
          },
          {
            tahun: "2017",
            tipe: "X",
            mesin: "1300",
            transmisi: "Manual",
            harga: 135000000,
          },
          {
            tahun: "2017",
            tipe: "X",
            mesin: "1300",
            transmisi: "Automatic",
            harga: 140000000,
          },
          {
            tahun: "2017",
            tipe: "R",
            mesin: "1300",
            transmisi: "Manual",
            harga: 145000000,
          },
          {
            tahun: "2017",
            tipe: "R",
            mesin: "1300",
            transmisi: "Automatic",
            harga: 145000000,
          },
          {
            tahun: "2017",
            tipe: "R ATTIVO",
            mesin: "1300",
            transmisi: "Manual",
            harga: 150000000,
          },
          {
            tahun: "2017",
            tipe: "R ATTIVO",
            mesin: "1300",
            transmisi: "Automatic",
            harga: 150000000,
          },
          {
            tahun: "2018",
            tipe: "D",
            mesin: "1000",
            transmisi: "Manual",
            harga: 125000000,
          },
          {
            tahun: "2018",
            tipe: "D",
            mesin: "1000",
            transmisi: "Automatic",
            harga: 130000000,
          },
          {
            tahun: "2018",
            tipe: "M",
            mesin: "1000",
            transmisi: "Manual",
            harga: 130000000,
          },
          {
            tahun: "2018",
            tipe: "M",
            mesin: "1000",
            transmisi: "Automatic",
            harga: 135000000,
          },
          {
            tahun: "2018",
            tipe: "X",
            mesin: "1300",
            transmisi: "Manual",
            harga: 140000000,
          },
          {
            tahun: "2018",
            tipe: "X",
            mesin: "1300",
            transmisi: "Automatic",
            harga: 145000000,
          },
          {
            tahun: "2018",
            tipe: "R",
            mesin: "1300",
            transmisi: "Manual",
            harga: 150000000,
          },
          {
            tahun: "2018",
            tipe: "R",
            mesin: "1300",
            transmisi: "Automatic",
            harga: 150000000,
          },
          {
            tahun: "2018",
            tipe: "R ATTIVO",
            mesin: "1300",
            transmisi: "Manual",
            harga: 155000000,
          },
          {
            tahun: "2018",
            tipe: "R ATTIVO",
            mesin: "1300",
            transmisi: "Automatic",
            harga: 155000000,
          },
          {
            tahun: "2019",
            tipe: "D",
            mesin: "1000",
            transmisi: "Manual",
            harga: 130000000,
          },
          {
            tahun: "2019",
            tipe: "D",
            mesin: "1000",
            transmisi: "Automatic",
            harga: 135000000,
          },
          {
            tahun: "2019",
            tipe: "M",
            mesin: "1000",
            transmisi: "Manual",
            harga: 135000000,
          },
          {
            tahun: "2019",
            tipe: "M",
            mesin: "1000",
            transmisi: "Automatic",
            harga: 140000000,
          },
          {
            tahun: "2019",
            tipe: "X",
            mesin: "1300",
            transmisi: "Manual",
            harga: 145000000,
          },
          {
            tahun: "2019",
            tipe: "X",
            mesin: "1300",
            transmisi: "Automatic",
            harga: 150000000,
          },
          {
            tahun: "2019",
            tipe: "R",
            mesin: "1300",
            transmisi: "Manual",
            harga: 155000000,
          },
          {
            tahun: "2019",
            tipe: "R",
            mesin: "1300",
            transmisi: "Automatic",
            harga: 155000000,
          },
          {
            tahun: "2019",
            tipe: "R ATTIVO",
            mesin: "1300",
            transmisi: "Manual",
            harga: 160000000,
          },
          {
            tahun: "2019",
            tipe: "R ATTIVO",
            mesin: "1300",
            transmisi: "Automatic",
            harga: 165000000,
          },
          {
            tahun: "2020",
            tipe: "D",
            mesin: "1000",
            transmisi: "Manual",
            harga: 135000000,
          },
          {
            tahun: "2020",
            tipe: "D",
            mesin: "1000",
            transmisi: "Automatic",
            harga: 140000000,
          },
          {
            tahun: "2020",
            tipe: "M",
            mesin: "1000",
            transmisi: "Manual",
            harga: 140000000,
          },
          {
            tahun: "2020",
            tipe: "M",
            mesin: "1000",
            transmisi: "Automatic",
            harga: 145000000,
          },
          {
            tahun: "2020",
            tipe: "X",
            mesin: "1300",
            transmisi: "Manual",
            harga: 150000000,
          },
          {
            tahun: "2020",
            tipe: "X",
            mesin: "1300",
            transmisi: "Automatic",
            harga: 155000000,
          },
          {
            tahun: "2020",
            tipe: "R",
            mesin: "1300",
            transmisi: "Manual",
            harga: 160000000,
          },
          {
            tahun: "2020",
            tipe: "R",
            mesin: "1300",
            transmisi: "Automatic",
            harga: 160000000,
          },
          {
            tahun: "2020",
            tipe: "R DELUXE",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 180000000,
          },
        ],
      },
    ],
  },
  {
    merek: "Honda",
    detail: [
      {
        detail_merek: "BRIO",
        detail_spek: [
          {
            tahun: "2015",
            tipe: "SATYA A",
            mesin: "1200",
            transmisi: "Manual",
            harga: 80000000,
          },
          {
            tahun: "2015",
            tipe: "SATYA S",
            mesin: "1200",
            transmisi: "Manual",
            harga: 85000000,
          },
          {
            tahun: "2015",
            tipe: "SATYA S",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 90000000,
          },
          {
            tahun: "2015",
            tipe: "SATYA E",
            mesin: "1200",
            transmisi: "Manual",
            harga: 95000000,
          },
          {
            tahun: "2015",
            tipe: "SATYA E",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 105000000,
          },
          {
            tahun: "2016",
            tipe: "S",
            mesin: "1200",
            transmisi: "Manual",
            harga: 90000000,
          },
          {
            tahun: "2016",
            tipe: "S",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 95000000,
          },
          {
            tahun: "2016",
            tipe: "E",
            mesin: "1200",
            transmisi: "Manual",
            harga: 100000000,
          },
          {
            tahun: "2016",
            tipe: "E",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 105000000,
          },
          {
            tahun: "2016",
            tipe: "RS",
            mesin: "1200",
            transmisi: "Manual",
            harga: 110000000,
          },
          {
            tahun: "2016",
            tipe: "RS",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 115000000,
          },
          {
            tahun: "2017",
            tipe: "S",
            mesin: "1200",
            transmisi: "Manual",
            harga: 95000000,
          },
          {
            tahun: "2017",
            tipe: "S",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 100000000,
          },
          {
            tahun: "2017",
            tipe: "E",
            mesin: "1200",
            transmisi: "Manual",
            harga: 105000000,
          },
          {
            tahun: "2017",
            tipe: "E",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 110000000,
          },
          {
            tahun: "2017",
            tipe: "RS",
            mesin: "1200",
            transmisi: "Manual",
            harga: 115000000,
          },
          {
            tahun: "2017",
            tipe: "RS",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 120000000,
          },
          {
            tahun: "2018",
            tipe: "S",
            mesin: "1200",
            transmisi: "Manual",
            harga: 100000000,
          },
          {
            tahun: "2018",
            tipe: "S",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 105000000,
          },
          {
            tahun: "2018",
            tipe: "E",
            mesin: "1200",
            transmisi: "Manual",
            harga: 110000000,
          },
          {
            tahun: "2018",
            tipe: "E",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 115000000,
          },
          {
            tahun: "2018",
            tipe: "RS",
            mesin: "1200",
            transmisi: "Manual",
            harga: 120000000,
          },
          {
            tahun: "2018",
            tipe: "RS",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 125000000,
          },
          {
            tahun: "2019",
            tipe: "S",
            mesin: "1200",
            transmisi: "Manual",
            harga: 105000000,
          },
          {
            tahun: "2019",
            tipe: "S",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 110000000,
          },
          {
            tahun: "2019",
            tipe: "E",
            mesin: "1200",
            transmisi: "Manual",
            harga: 115000000,
          },
          {
            tahun: "2019",
            tipe: "E",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 120000000,
          },
          {
            tahun: "2019",
            tipe: "RS",
            mesin: "1200",
            transmisi: "Manual",
            harga: 125000000,
          },
          {
            tahun: "2019",
            tipe: "RS",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 130000000,
          },
          {
            tahun: "2020",
            tipe: "S",
            mesin: "1200",
            transmisi: "Manual",
            harga: 110000000,
          },
          {
            tahun: "2020",
            tipe: "S",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 115000000,
          },
          {
            tahun: "2020",
            tipe: "E",
            mesin: "1200",
            transmisi: "Manual",
            harga: 120000000,
          },
          {
            tahun: "2020",
            tipe: "E",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 125000000,
          },
          {
            tahun: "2020",
            tipe: "RS",
            mesin: "1200",
            transmisi: "Manual",
            harga: 130000000,
          },
          {
            tahun: "2020",
            tipe: "RS",
            mesin: "1200",
            transmisi: "Automatic",
            harga: 135000000,
          },
        ],
      },
      {
        detail_merek: "BR-V",
        detail_spek: [
          {
            tahun: "2015",
            tipe: "S",
            mesin: "1500",
            transmisi: "Manual",
            harga: 125000000,
          },
          {
            tahun: "2015",
            tipe: "E",
            mesin: "1500",
            transmisi: "Manual",
            harga: 130000000,
          },
          {
            tahun: "2015",
            tipe: "E",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 135000000,
          },
          {
            tahun: "2015",
            tipe: "PRESTIGE",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 145000000,
          },
          {
            tahun: "2016",
            tipe: "S",
            mesin: "1500",
            transmisi: "Manual",
            harga: 130000000,
          },
          {
            tahun: "2016",
            tipe: "E",
            mesin: "1500",
            transmisi: "Manual",
            harga: 135000000,
          },
          {
            tahun: "2016",
            tipe: "E",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 140000000,
          },
          {
            tahun: "2016",
            tipe: "PRESTIGE",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 150000000,
          },
          {
            tahun: "2017",
            tipe: "S",
            mesin: "1500",
            transmisi: "Manual",
            harga: 135000000,
          },
          {
            tahun: "2017",
            tipe: "E",
            mesin: "1500",
            transmisi: "Manual",
            harga: 140000000,
          },
          {
            tahun: "2017",
            tipe: "E",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 145000000,
          },
          {
            tahun: "2017",
            tipe: "PRESTIGE",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 155000000,
          },
          {
            tahun: "2018",
            tipe: "S",
            mesin: "1500",
            transmisi: "Manual",
            harga: 140000000,
          },
          {
            tahun: "2018",
            tipe: "E",
            mesin: "1500",
            transmisi: "Manual",
            harga: 145000000,
          },
          {
            tahun: "2018",
            tipe: "E",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 150000000,
          },
          {
            tahun: "2018",
            tipe: "PRESTIGE",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 165000000,
          },
          {
            tahun: "2019",
            tipe: "S",
            mesin: "1500",
            transmisi: "Manual",
            harga: 145000000,
          },
          {
            tahun: "2019",
            tipe: "E",
            mesin: "1500",
            transmisi: "Manual",
            harga: 150000000,
          },
          {
            tahun: "2019",
            tipe: "E",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 155000000,
          },
          {
            tahun: "2019",
            tipe: "PRESTIGE",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 175000000,
          },
          {
            tahun: "2020",
            tipe: "S",
            mesin: "1500",
            transmisi: "Manual",
            harga: 150000000,
          },
          {
            tahun: "2020",
            tipe: "E",
            mesin: "1500",
            transmisi: "Manual",
            harga: 155000000,
          },
          {
            tahun: "2020",
            tipe: "E",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 160000000,
          },
          {
            tahun: "2020",
            tipe: "PRESTIGE",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 185000000,
          },
        ],
      },
      {
        detail_merek: "CR-V",
        detail_spek: [
          {
            tahun: "2015",
            tipe: "NO VARIANT",
            mesin: "2000",
            transmisi: "Manual",
            harga: 200000000,
          },
          {
            tahun: "2015",
            tipe: "NO VARIANT",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 210000000,
          },
          {
            tahun: "2015",
            tipe: "NO VARIANT",
            mesin: "2400",
            transmisi: "Automatic",
            harga: 210000000,
          },
          {
            tahun: "2015",
            tipe: "PRESTIGE",
            mesin: "2400",
            transmisi: "Automatic",
            harga: 245000000,
          },
          {
            tahun: "2016",
            tipe: "NO VARIANT",
            mesin: "2000",
            transmisi: "Manual",
            harga: 230000000,
          },
          {
            tahun: "2016",
            tipe: "NO VARIANT",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 240000000,
          },
          {
            tahun: "2016",
            tipe: "NO VARIANT",
            mesin: "2400",
            transmisi: "Automatic",
            harga: 230000000,
          },
          {
            tahun: "2016",
            tipe: "PRESTIGE",
            mesin: "2400",
            transmisi: "Automatic",
            harga: 270000000,
          },
          {
            tahun: "2017",
            tipe: "NO VARIANT",
            mesin: "2000",
            transmisi: "Manual",
            harga: 240000000,
          },
          {
            tahun: "2017",
            tipe: "NO VARIANT",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 270000000,
          },
          {
            tahun: "2017",
            tipe: "NO VARIANT",
            mesin: "2400",
            transmisi: "Automatic",
            harga: 260000000,
          },
          {
            tahun: "2017",
            tipe: "PRESTIGE",
            mesin: "2400",
            transmisi: "Automatic",
            harga: 290000000,
          },
          {
            tahun: "2017",
            tipe: "TURBO",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 360000000,
          },
          {
            tahun: "2017",
            tipe: "TURBO PRESTIGE",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 380000000,
          },
          {
            tahun: "2018",
            tipe: "TURBO",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 370000000,
          },
          {
            tahun: "2018",
            tipe: "TURBO PRESTIGE",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 420000000,
          },
          {
            tahun: "2019",
            tipe: "TURBO",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 380000000,
          },
          {
            tahun: "2019",
            tipe: "TURBO PRESTIGE",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 440000000,
          },
          {
            tahun: "2020",
            tipe: "TURBO",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 420000000,
          },
          {
            tahun: "2020",
            tipe: "TURBO PRESTIGE",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 470000000,
          },
        ],
      },
      {
        detail_merek: "HR-V",
        detail_spek: [
          {
            tahun: "2015",
            tipe: "S",
            mesin: "1500",
            transmisi: "Manual",
            harga: 170000000,
          },
          {
            tahun: "2015",
            tipe: "S",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 175000000,
          },
          {
            tahun: "2015",
            tipe: "E",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 195000000,
          },
          {
            tahun: "2015",
            tipe: "E",
            mesin: "1800",
            transmisi: "Automatic",
            harga: 200000000,
          },
          {
            tahun: "2015",
            tipe: "PRESTIGE",
            mesin: "1800",
            transmisi: "Automatic",
            harga: 215000000,
          },
          {
            tahun: "2016",
            tipe: "S",
            mesin: "1500",
            transmisi: "Manual",
            harga: 175000000,
          },
          {
            tahun: "2016",
            tipe: "S",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 180000000,
          },
          {
            tahun: "2016",
            tipe: "E",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 200000000,
          },
          {
            tahun: "2016",
            tipe: "E",
            mesin: "1800",
            transmisi: "Automatic",
            harga: 215000000,
          },
          {
            tahun: "2016",
            tipe: "PRESTIGE",
            mesin: "1800",
            transmisi: "Automatic",
            harga: 230000000,
          },
          {
            tahun: "2017",
            tipe: "S",
            mesin: "1500",
            transmisi: "Manual",
            harga: 180000000,
          },
          {
            tahun: "2017",
            tipe: "S",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 185000000,
          },
          {
            tahun: "2017",
            tipe: "E",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 210000000,
          },
          {
            tahun: "2017",
            tipe: "E",
            mesin: "1800",
            transmisi: "Automatic",
            harga: 225000000,
          },
          {
            tahun: "2017",
            tipe: "PRESTIGE",
            mesin: "1800",
            transmisi: "Automatic",
            harga: 250000000,
          },
          {
            tahun: "2018",
            tipe: "S",
            mesin: "1500",
            transmisi: "Manual",
            harga: 185000000,
          },
          {
            tahun: "2018",
            tipe: "S",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 190000000,
          },
          {
            tahun: "2018",
            tipe: "E",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 220000000,
          },
          {
            tahun: "2018",
            tipe: "E",
            mesin: "1800",
            transmisi: "Automatic",
            harga: 230000000,
          },
          {
            tahun: "2018",
            tipe: "PRESTIGE",
            mesin: "1800",
            transmisi: "Automatic",
            harga: 265000000,
          },
          {
            tahun: "2019",
            tipe: "S",
            mesin: "1500",
            transmisi: "Manual",
            harga: 190000000,
          },
          {
            tahun: "2019",
            tipe: "S",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 195000000,
          },
          {
            tahun: "2019",
            tipe: "E",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 230000000,
          },
          {
            tahun: "2019",
            tipe: "E",
            mesin: "1800",
            transmisi: "Automatic",
            harga: 240000000,
          },
          {
            tahun: "2019",
            tipe: "PRESTIGE",
            mesin: "1800",
            transmisi: "Automatic",
            harga: 275000000,
          },
          {
            tahun: "2020",
            tipe: "S",
            mesin: "1500",
            transmisi: "Manual",
            harga: 195000000,
          },
          {
            tahun: "2020",
            tipe: "S",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 200000000,
          },
          {
            tahun: "2020",
            tipe: "E",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 240000000,
          },
          {
            tahun: "2020",
            tipe: "E",
            mesin: "1800",
            transmisi: "Automatic",
            harga: 250000000,
          },
          {
            tahun: "2020",
            tipe: "PRESTIGE",
            mesin: "1800",
            transmisi: "Automatic",
            harga: 285000000,
          },
        ],
      },
      {
        detail_merek: "JAZZ",
        detail_spek: [
          {
            tahun: "2015",
            tipe: "S",
            mesin: "1500",
            transmisi: "Manual",
            harga: 170000000,
          },
          {
            tahun: "2015",
            tipe: "S",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 175000000,
          },
          {
            tahun: "2015",
            tipe: "RS",
            mesin: "1500",
            transmisi: "Manual",
            harga: 200000000,
          },
          {
            tahun: "2015",
            tipe: "RS",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 205000000,
          },
          {
            tahun: "2016",
            tipe: "S",
            mesin: "1500",
            transmisi: "Manual",
            harga: 180000000,
          },
          {
            tahun: "2016",
            tipe: "S",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 185000000,
          },
          {
            tahun: "2016",
            tipe: "RS",
            mesin: "1500",
            transmisi: "Manual",
            harga: 210000000,
          },
          {
            tahun: "2016",
            tipe: "RS",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 215000000,
          },
          {
            tahun: "2017",
            tipe: "S",
            mesin: "1500",
            transmisi: "Manual",
            harga: 190000000,
          },
          {
            tahun: "2017",
            tipe: "S",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 195000000,
          },
          {
            tahun: "2017",
            tipe: "RS",
            mesin: "1500",
            transmisi: "Manual",
            harga: 200000000,
          },
          {
            tahun: "2017",
            tipe: "RS",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 220000000,
          },
          {
            tahun: "2018",
            tipe: "S",
            mesin: "1500",
            transmisi: "Manual",
            harga: 195000000,
          },
          {
            tahun: "2018",
            tipe: "S",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 205000000,
          },
          {
            tahun: "2018",
            tipe: "RS",
            mesin: "1500",
            transmisi: "Manual",
            harga: 215000000,
          },
          {
            tahun: "2018",
            tipe: "RS",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 230000000,
          },
          {
            tahun: "2019",
            tipe: "S",
            mesin: "1500",
            transmisi: "Manual",
            harga: 205000000,
          },
          {
            tahun: "2019",
            tipe: "S",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 215000000,
          },
          {
            tahun: "2019",
            tipe: "RS",
            mesin: "1500",
            transmisi: "Manual",
            harga: 225000000,
          },
          {
            tahun: "2019",
            tipe: "RS",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 240000000,
          },
          {
            tahun: "2020",
            tipe: "S",
            mesin: "1500",
            transmisi: "Manual",
            harga: 215000000,
          },
          {
            tahun: "2020",
            tipe: "S",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 225000000,
          },
          {
            tahun: "2020",
            tipe: "RS",
            mesin: "1500",
            transmisi: "Manual",
            harga: 235000000,
          },
          {
            tahun: "2020",
            tipe: "RS",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 250000000,
          },
        ],
      },
      {
        detail_merek: "MOBILIO",
        detail_spek: [
          {
            tahun: "2015",
            tipe: "S",
            mesin: "1500",
            transmisi: "Manual",
            harga: 110000000,
          },
          {
            tahun: "2015",
            tipe: "E",
            mesin: "1500",
            transmisi: "Manual",
            harga: 120000000,
          },
          {
            tahun: "2015",
            tipe: "E",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 130000000,
          },
          {
            tahun: "2015",
            tipe: "E PRESTIGE",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 135000000,
          },
          {
            tahun: "2015",
            tipe: "RS",
            mesin: "1500",
            transmisi: "Manual",
            harga: 140000000,
          },
          {
            tahun: "2015",
            tipe: "RS",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 150000000,
          },
          {
            tahun: "2016",
            tipe: "S",
            mesin: "1500",
            transmisi: "Manual",
            harga: 120000000,
          },
          {
            tahun: "2016",
            tipe: "E",
            mesin: "1500",
            transmisi: "Manual",
            harga: 130000000,
          },
          {
            tahun: "2016",
            tipe: "E",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 140000000,
          },
          {
            tahun: "2016",
            tipe: "E PRESTIGE",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 150000000,
          },
          {
            tahun: "2016",
            tipe: "RS",
            mesin: "1500",
            transmisi: "Manual",
            harga: 160000000,
          },
          {
            tahun: "2016",
            tipe: "RS",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 170000000,
          },
          {
            tahun: "2017",
            tipe: "S",
            mesin: "1500",
            transmisi: "Manual",
            harga: 130000000,
          },
          {
            tahun: "2017",
            tipe: "E",
            mesin: "1500",
            transmisi: "Manual",
            harga: 140000000,
          },
          {
            tahun: "2017",
            tipe: "E",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 150000000,
          },
          {
            tahun: "2017",
            tipe: "E PRESTIGE",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 160000000,
          },
          {
            tahun: "2017",
            tipe: "RS",
            mesin: "1500",
            transmisi: "Manual",
            harga: 170000000,
          },
          {
            tahun: "2017",
            tipe: "RS",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 180000000,
          },
          {
            tahun: "2018",
            tipe: "S",
            mesin: "1500",
            transmisi: "Manual",
            harga: 140000000,
          },
          {
            tahun: "2018",
            tipe: "E",
            mesin: "1500",
            transmisi: "Manual",
            harga: 150000000,
          },
          {
            tahun: "2018",
            tipe: "E",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 160000000,
          },
          {
            tahun: "2018",
            tipe: "E PRESTIGE",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 170000000,
          },
          {
            tahun: "2018",
            tipe: "RS",
            mesin: "1500",
            transmisi: "Manual",
            harga: 180000000,
          },
          {
            tahun: "2018",
            tipe: "RS",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 190000000,
          },
          {
            tahun: "2019",
            tipe: "S",
            mesin: "1500",
            transmisi: "Manual",
            harga: 150000000,
          },
          {
            tahun: "2019",
            tipe: "E",
            mesin: "1500",
            transmisi: "Manual",
            harga: 160000000,
          },
          {
            tahun: "2019",
            tipe: "E",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 170000000,
          },
          {
            tahun: "2019",
            tipe: "E PRESTIGE",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 180000000,
          },
          {
            tahun: "2019",
            tipe: "RS",
            mesin: "1500",
            transmisi: "Manual",
            harga: 190000000,
          },
          {
            tahun: "2019",
            tipe: "RS",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 200000000,
          },
          {
            tahun: "2020",
            tipe: "S",
            mesin: "1500",
            transmisi: "Manual",
            harga: 160000000,
          },
          {
            tahun: "2020",
            tipe: "E",
            mesin: "1500",
            transmisi: "Manual",
            harga: 170000000,
          },
          {
            tahun: "2020",
            tipe: "E",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 180000000,
          },
          {
            tahun: "2020",
            tipe: "E PRESTIGE",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 190000000,
          },
          {
            tahun: "2020",
            tipe: "RS",
            mesin: "1500",
            transmisi: "Manual",
            harga: 200000000,
          },
          {
            tahun: "2020",
            tipe: "RS",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 210000000,
          },
        ],
      },
    ],
  },
  {
    merek: "Mazda",
    detail: [
      {
        detail_merek: "2",
        detail_spek: [
          {
            tahun: "2015",
            tipe: "V SKYACTIV",
            mesin: "1500",
            transmisi: "Manual",
            harga: 140000000,
          },
          {
            tahun: "2015",
            tipe: "V SKYACTIV",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 150000000,
          },
          {
            tahun: "2015",
            tipe: "R SKYACTIV",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 160000000,
          },
          {
            tahun: "2015",
            tipe: "GT SKYACTIV",
            mesin: "1500",
            transmisi: "Manual",
            harga: 190000000,
          },
          {
            tahun: "2016",
            tipe: "V SKYACTIV",
            mesin: "1500",
            transmisi: "Manual",
            harga: 150000000,
          },
          {
            tahun: "2016",
            tipe: "V SKYACTIV",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 160000000,
          },
          {
            tahun: "2016",
            tipe: "R SKYACTIV",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 180000000,
          },
          {
            tahun: "2016",
            tipe: "GT SKYACTIV",
            mesin: "1500",
            transmisi: "Manual",
            harga: 200000000,
          },
          {
            tahun: "2017",
            tipe: "R SKYACTIV",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 190000000,
          },
          {
            tahun: "2017",
            tipe: "GT SKYACTIV",
            mesin: "1500",
            transmisi: "Manual",
            harga: 220000000,
          },
          {
            tahun: "2018",
            tipe: "R SKYACTIV",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 200000000,
          },
          {
            tahun: "2018",
            tipe: "GT SKYACTIV",
            mesin: "1500",
            transmisi: "Manual",
            harga: 230000000,
          },
          {
            tahun: "2019",
            tipe: "R SKYACTIV",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 210000000,
          },
          {
            tahun: "2019",
            tipe: "GT SKYACTIV",
            mesin: "1500",
            transmisi: "Manual",
            harga: 240000000,
          },
          {
            tahun: "2020",
            tipe: "R SKYACTIV",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 220000000,
          },
          {
            tahun: "2020",
            tipe: "GT SKYACTIV",
            mesin: "1500",
            transmisi: "Manual",
            harga: 250000000,
          },
        ],
      },
      {
        detail_merek: "3",
        detail_spek: [
          {
            tahun: "2017",
            tipe: "NO VARIANT",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 350000000,
          },
          {
            tahun: "2018",
            tipe: "HATCHBACK",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 360000000,
          },
          {
            tahun: "2019",
            tipe: "HATCHBACK",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 420000000,
          },
          {
            tahun: "2020",
            tipe: "HATCHBACK",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 450000000,
          },
        ],
      },
      {
        detail_merek: "6",
        detail_spek: [
          {
            tahun: "2015",
            tipe: "NO VARIANT",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 300000000,
          },
          {
            tahun: "2016",
            tipe: "NO VARIANT",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 350000000,
          },
          {
            tahun: "2017",
            tipe: "SKYACTIV",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 400000000,
          },
          {
            tahun: "2017",
            tipe: "ESTATE",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 425000000,
          },
          {
            tahun: "2018",
            tipe: "ESTATE",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 480000000,
          },
          {
            tahun: "2019",
            tipe: "ESTATE",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 530000000,
          },
          {
            tahun: "2020",
            tipe: "ESTATE",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 570000000,
          },
        ],
      },
      {
        detail_merek: "BIANTE",
        detail_spek: [
          {
            tahun: "2015",
            tipe: "SKYACTIV",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 220000000,
          },
          {
            tahun: "2016",
            tipe: "SKYACTIV",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 240000000,
          },
          {
            tahun: "2017",
            tipe: "SKYACTIV",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 260000000,
          },
        ],
      },
      {
        detail_merek: "CX-5",
        detail_spek: [
          {
            tahun: "2015",
            tipe: "TOURING",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 220000000,
          },
          {
            tahun: "2015",
            tipe: "GT",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 270000000,
          },
          {
            tahun: "2016",
            tipe: "TOURING",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 290000000,
          },
          {
            tahun: "2016",
            tipe: "GT",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 320000000,
          },
          {
            tahun: "2017",
            tipe: "TOURING",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 310000000,
          },
          {
            tahun: "2017",
            tipe: "GT",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 350000000,
          },
          {
            tahun: "2017",
            tipe: "ELITE",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 420000000,
          },
          {
            tahun: "2018",
            tipe: "GT",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 400000000,
          },
          {
            tahun: "2018",
            tipe: "ELITE",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 450000000,
          },
          {
            tahun: "2019",
            tipe: "GT",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 420000000,
          },
          {
            tahun: "2019",
            tipe: "ELITE",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 480000000,
          },
          {
            tahun: "2020",
            tipe: "GT",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 500000000,
          },
        ],
      },
    ],
  },
  {
    merek: "Mitsubishi",
    detail: [
      {
        detail_merek: "XPANDER",
        detail_spek: [
          {
            tahun: "2017",
            tipe: "GLS",
            mesin: "1500",
            transmisi: "Manual",
            harga: 130000000,
          },
          {
            tahun: "2017",
            tipe: "EXCEED",
            mesin: "1500",
            transmisi: "Manual",
            harga: 140000000,
          },
          {
            tahun: "2017",
            tipe: "EXCEED",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 145000000,
          },
          {
            tahun: "2017",
            tipe: "SPORT",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 160000000,
          },
          {
            tahun: "2017",
            tipe: "ULTIMATE",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 165000000,
          },
          {
            tahun: "2018",
            tipe: "GLS",
            mesin: "1500",
            transmisi: "Manual",
            harga: 140000000,
          },
          {
            tahun: "2018",
            tipe: "EXCEED",
            mesin: "1500",
            transmisi: "Manual",
            harga: 150000000,
          },
          {
            tahun: "2018",
            tipe: "EXCEED",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 155000000,
          },
          {
            tahun: "2018",
            tipe: "SPORT",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 170000000,
          },
          {
            tahun: "2018",
            tipe: "ULTIMATE",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 175000000,
          },
          {
            tahun: "2019",
            tipe: "GLS",
            mesin: "1500",
            transmisi: "Manual",
            harga: 150000000,
          },
          {
            tahun: "2019",
            tipe: "EXCEED",
            mesin: "1500",
            transmisi: "Manual",
            harga: 160000000,
          },
          {
            tahun: "2019",
            tipe: "EXCEED",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 165000000,
          },
          {
            tahun: "2019",
            tipe: "SPORT",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 180000000,
          },
          {
            tahun: "2019",
            tipe: "ULTIMATE",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 190000000,
          },
          {
            tahun: "2020",
            tipe: "GLS",
            mesin: "1500",
            transmisi: "Manual",
            harga: 160000000,
          },
          {
            tahun: "2020",
            tipe: "EXCEED",
            mesin: "1500",
            transmisi: "Manual",
            harga: 170000000,
          },
          {
            tahun: "2020",
            tipe: "EXCEED",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 175000000,
          },
          {
            tahun: "2020",
            tipe: "SPORT",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 190000000,
          },
          {
            tahun: "2020",
            tipe: "ULTIMATE",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 200000000,
          },
        ],
      },
      {
        detail_merek: "OUTLANDER SPORT",
        detail_spek: [
          {
            tahun: "2015",
            tipe: "GLS",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 140000000,
          },
          {
            tahun: "2015",
            tipe: "GLX",
            mesin: "2000",
            transmisi: "Manual",
            harga: 140000000,
          },
          {
            tahun: "2015",
            tipe: "PX",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 180000000,
          },
          {
            tahun: "2016",
            tipe: "GLS",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 150000000,
          },
          {
            tahun: "2016",
            tipe: "GLX",
            mesin: "2000",
            transmisi: "Manual",
            harga: 150000000,
          },
          {
            tahun: "2016",
            tipe: "PX",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 200000000,
          },
          {
            tahun: "2017",
            tipe: "GLS",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 160000000,
          },
          {
            tahun: "2017",
            tipe: "GLX",
            mesin: "2000",
            transmisi: "Manual",
            harga: 160000000,
          },
          {
            tahun: "2017",
            tipe: "PX",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 210000000,
          },
          {
            tahun: "2018",
            tipe: "GLS",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 170000000,
          },
          {
            tahun: "2018",
            tipe: "GLX",
            mesin: "2000",
            transmisi: "Manual",
            harga: 170000000,
          },
          {
            tahun: "2018",
            tipe: "PX",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 220000000,
          },
        ],
      },
      {
        detail_merek: "PAJERO SPORT",
        detail_spek: [
          {
            tahun: "2015",
            tipe: "GLS",
            mesin: "2500",
            transmisi: "Manual",
            harga: 260000000,
          },
          {
            tahun: "2015",
            tipe: "EXCEED",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 270000000,
          },
          {
            tahun: "2015",
            tipe: "DAKAR 4X2",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 280000000,
          },
          {
            tahun: "2015",
            tipe: "DAKAR 4X4",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 320000000,
          },
          {
            tahun: "2016",
            tipe: "EXCEED",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 360000000,
          },
          {
            tahun: "2016",
            tipe: "DAKAR 4X2",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 380000000,
          },
          {
            tahun: "2016",
            tipe: "DAKAR 4X4",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 450000000,
          },
          {
            tahun: "2017",
            tipe: "EXCEED",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 380000000,
          },
          {
            tahun: "2017",
            tipe: "DAKAR ULTIMATE",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 420000000,
          },
          {
            tahun: "2017",
            tipe: "DAKAR 4X2",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 420000000,
          },
          {
            tahun: "2017",
            tipe: "DAKAR 4X4",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 500000000,
          },
          {
            tahun: "2018",
            tipe: "EXCEED",
            mesin: "2500",
            transmisi: "Manual",
            harga: 400000000,
          },
          {
            tahun: "2018",
            tipe: "EXCEED",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 405000000,
          },
          {
            tahun: "2018",
            tipe: "DAKAR ULTIMATE",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 450000000,
          },
          {
            tahun: "2018",
            tipe: "DAKAR 4X2",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 500000000,
          },
          {
            tahun: "2018",
            tipe: "DAKAR 4X4",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 550000000,
          },
          {
            tahun: "2019",
            tipe: "EXCEED",
            mesin: "2500",
            transmisi: "Manual",
            harga: 420000000,
          },
          {
            tahun: "2019",
            tipe: "EXCEED",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 425000000,
          },
          {
            tahun: "2019",
            tipe: "DAKAR ULTIMATE",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 480000000,
          },
          {
            tahun: "2019",
            tipe: "DAKAR 4X2",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 510000000,
          },
          {
            tahun: "2019",
            tipe: "DAKAR 4X4",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 600000000,
          },
          {
            tahun: "2020",
            tipe: "EXCEED",
            mesin: "2500",
            transmisi: "Manual",
            harga: 440000000,
          },
          {
            tahun: "2020",
            tipe: "EXCEED",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 445000000,
          },
          {
            tahun: "2020",
            tipe: "DAKAR ULTIMATE",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 490000000,
          },
          {
            tahun: "2020",
            tipe: "DAKAR 4X2",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 500000000,
          },
          {
            tahun: "2020",
            tipe: "DAKAR 4X4",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 630000000,
          },
        ],
      },
    ],
  },
  {
    merek: "Nissan",
    detail: [
      {
        detail_merek: "GRAND LIVINA",
        detail_spek: [
          {
            tahun: "2015",
            tipe: "SV",
            mesin: "1500",
            transmisi: "Manual",
            harga: 140000000,
          },
          {
            tahun: "2015",
            tipe: "SV",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 140000000,
          },
          {
            tahun: "2015",
            tipe: "XV",
            mesin: "1500",
            transmisi: "Manual",
            harga: 145000000,
          },
          {
            tahun: "2015",
            tipe: "XV",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 150000000,
          },
          {
            tahun: "2015",
            tipe: "X-GEAR",
            mesin: "1500",
            transmisi: "Manual",
            harga: 135000000,
          },
          {
            tahun: "2015",
            tipe: "X-GEAR",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 135000000,
          },
          {
            tahun: "2015",
            tipe: "HIGHWAY STAR",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 160000000,
          },
          {
            tahun: "2016",
            tipe: "SV",
            mesin: "1500",
            transmisi: "Manual",
            harga: 150000000,
          },
          {
            tahun: "2016",
            tipe: "SV",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 150000000,
          },
          {
            tahun: "2016",
            tipe: "XV",
            mesin: "1500",
            transmisi: "Manual",
            harga: 155000000,
          },
          {
            tahun: "2016",
            tipe: "XV",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 160000000,
          },
          {
            tahun: "2016",
            tipe: "X-GEAR",
            mesin: "1500",
            transmisi: "Manual",
            harga: 150000000,
          },
          {
            tahun: "2016",
            tipe: "X-GEAR",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 150000000,
          },
          {
            tahun: "2016",
            tipe: "HIGHWAY STAR",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 170000000,
          },
          {
            tahun: "2017",
            tipe: "SV",
            mesin: "1500",
            transmisi: "Manual",
            harga: 160000000,
          },
          {
            tahun: "2017",
            tipe: "SV",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 160000000,
          },
          {
            tahun: "2017",
            tipe: "XV",
            mesin: "1500",
            transmisi: "Manual",
            harga: 170000000,
          },
          {
            tahun: "2017",
            tipe: "XV",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 170000000,
          },
          {
            tahun: "2017",
            tipe: "X-GEAR",
            mesin: "1500",
            transmisi: "Manual",
            harga: 170000000,
          },
          {
            tahun: "2017",
            tipe: "X-GEAR",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 170000000,
          },
          {
            tahun: "2017",
            tipe: "HIGHWAY STAR",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 180000000,
          },
          {
            tahun: "2018",
            tipe: "SV",
            mesin: "1500",
            transmisi: "Manual",
            harga: 170000000,
          },
          {
            tahun: "2018",
            tipe: "SV",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 170000000,
          },
          {
            tahun: "2018",
            tipe: "XV",
            mesin: "1500",
            transmisi: "Manual",
            harga: 180000000,
          },
          {
            tahun: "2018",
            tipe: "XV",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 180000000,
          },
          {
            tahun: "2018",
            tipe: "X-GEAR",
            mesin: "1500",
            transmisi: "Manual",
            harga: 190000000,
          },
          {
            tahun: "2018",
            tipe: "X-GEAR",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 190000000,
          },
          {
            tahun: "2018",
            tipe: "HIGHWAY STAR",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 190000000,
          },
          {
            tahun: "2019",
            tipe: "E",
            mesin: "1500",
            transmisi: "Manual",
            harga: 190000000,
          },
          {
            tahun: "2019",
            tipe: "EL",
            mesin: "1500",
            transmisi: "Manual",
            harga: 195000000,
          },
          {
            tahun: "2019",
            tipe: "EL",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 200000000,
          },
          {
            tahun: "2019",
            tipe: "VE",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 205000000,
          },
          {
            tahun: "2019",
            tipe: "VL",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 215000000,
          },
          {
            tahun: "2020",
            tipe: "E",
            mesin: "1500",
            transmisi: "Manual",
            harga: 200000000,
          },
          {
            tahun: "2020",
            tipe: "EL",
            mesin: "1500",
            transmisi: "Manual",
            harga: 205000000,
          },
          {
            tahun: "2020",
            tipe: "EL",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 210000000,
          },
          {
            tahun: "2020",
            tipe: "VE",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 215000000,
          },
          {
            tahun: "2020",
            tipe: "VL",
            mesin: "1500",
            transmisi: "Automatic",
            harga: 220000000,
          },
        ],
      },
      {
        detail_merek: "SERENA",
        detail_spek: [
          {
            tahun: "2015",
            tipe: "X",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 200000000,
          },
          {
            tahun: "2015",
            tipe: "HIGHWAY STAR",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 235000000,
          },
          {
            tahun: "2015",
            tipe: "HIGHWAY STAR PANORAMIC",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 330000000,
          },
          {
            tahun: "2016",
            tipe: "X",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 240000000,
          },
          {
            tahun: "2016",
            tipe: "HIGHWAY STAR",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 290000000,
          },
          {
            tahun: "2016",
            tipe: "HIGHWAY STAR PANORAMIC",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 350000000,
          },
          {
            tahun: "2017",
            tipe: "X",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 250000000,
          },
          {
            tahun: "2017",
            tipe: "HIGHWAY STAR",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 300000000,
          },
          {
            tahun: "2017",
            tipe: "HIGHWAY STAR PANORAMIC",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 360000000,
          },
          {
            tahun: "2018",
            tipe: "X",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 260000000,
          },
          {
            tahun: "2018",
            tipe: "HIGHWAY STAR",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 310000000,
          },
          {
            tahun: "2018",
            tipe: "HIGHWAY STAR PANORAMIC",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 370000000,
          },
          {
            tahun: "2019",
            tipe: "X",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 270000000,
          },
          {
            tahun: "2019",
            tipe: "HIGHWAY STAR",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 320000000,
          },
          {
            tahun: "2019",
            tipe: "HIGHWAY STAR PANORAMIC",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 380000000,
          },
        ],
      },
      {
        detail_merek: "X-TRAIL",
        detail_spek: [
          {
            tahun: "2015",
            tipe: "NO VARIANT",
            mesin: "2000",
            transmisi: "Manual",
            harga: 230000000,
          },
          {
            tahun: "2015",
            tipe: "NO VARIANT",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 230000000,
          },
          {
            tahun: "2015",
            tipe: "XT",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 260000000,
          },
          {
            tahun: "2016",
            tipe: "NO VARIANT",
            mesin: "2000",
            transmisi: "Manual",
            harga: 250000000,
          },
          {
            tahun: "2016",
            tipe: "NO VARIANT",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 250000000,
          },
          {
            tahun: "2016",
            tipe: "NO VARIANT",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 280000000,
          },
          {
            tahun: "2017",
            tipe: "NO VARIANT",
            mesin: "2000",
            transmisi: "Manual",
            harga: 260000000,
          },
          {
            tahun: "2017",
            tipe: "NO VARIANT",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 260000000,
          },
          {
            tahun: "2017",
            tipe: "NO VARIANT",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 340000000,
          },
          {
            tahun: "2017",
            tipe: "EXTREMER",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 370000000,
          },
          {
            tahun: "2018",
            tipe: "NO VARIANT",
            mesin: "2000",
            transmisi: "Manual",
            harga: 270000000,
          },
          {
            tahun: "2018",
            tipe: "NO VARIANT",
            mesin: "2000",
            transmisi: "Automatic",
            harga: 270000000,
          },
          {
            tahun: "2018",
            tipe: "NO VARIANT",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 350000000,
          },
          {
            tahun: "2018",
            tipe: "CVT",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 400000000,
          },
          {
            tahun: "2018",
            tipe: "EXTREMER",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 420000000,
          },
          {
            tahun: "2019",
            tipe: "VL",
            mesin: "2500",
            transmisi: "Automatic",
            harga: 490000000,
          },
        ],
      },
    ],
  },
];
